export * from './app.component';
export * from './app.module';



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/index.ts